import type { NotificationItem, User } from "./types";

export function notificationRoute(item: NotificationItem, currentUser: Pick<User, "role">): string | null {
  if (item.entityType === "feedback_report" && item.entityId) {
    return currentUser.role === "admin"
      ? `management?tab=feedback&feedback=${encodeURIComponent(String(item.entityId))}`
      : `feedback?id=${encodeURIComponent(String(item.entityId))}`;
  }
  const link = item.link;
  if (!link) return null;
  const hashRoute = link.match(/#\/?(.*)$/)?.[1];
  let route = hashRoute
    ? hashRoute.replace(/^\/+/, "") || "home"
    : link.replace(/^https?:\/\/[^/]+/i, "").replace(/^\/+/, "") || "home";
  if (/^missions(?:\?|$)/.test(route)) {
    const [path, search = ""] = route.split("?", 2);
    const params = new URLSearchParams(search);
    const missionId = params.get("mission");
    if (missionId && !params.has("focus")) params.set("focus", missionId);
    route = `${path}${params.size ? `?${params}` : ""}`;
  }
  if (!item.entityId || !["leave_request", "shift_change_request"].includes(item.entityType ?? "")) return route;
  if (!/^(approvals|requests)(?:\?|$)/.test(route)) return route;
  return `${route}${route.includes("?") ? "&" : "?"}focus=${encodeURIComponent(String(item.entityId))}`;
}
